<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Perfis de Usuário</strong>
        </div>
        <b-form @submit.stop.prevent>
          <b-form-group label="Username (CPF)" label-for="username">
            <b-form-input id="username" :disabled="user.id != null" v-model="user.username"></b-form-input>
          </b-form-group>
          <b-form-group label="Ambiente" label-for="user-provider-environment">
            <b-form-select v-model="provider" disabled id="user-provider-environment">
              <option value="vault">Vault</option>
              <option value="bird">Bird</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Perfis" label-for="list-role">
            <div  class="input-group input-group-sm">
              <b-form-select v-model="role" :options="roles" value-field="id" text-field="name" id="list-role">
              </b-form-select>
              <span class="input-group-append">
                <button id="btn-add" class="btn btn-secondary" type="button" @click="addRole" @click.stop.prevent><i class="fa fa-plus"></i></button>
              </span>
            </div>
          </b-form-group>
          <hr>
          <b-form-group>
            <b-card-group deck>
              <b-col sm="12" lg="3" v-if="!user.roles || user.roles.length == 0">
                <b-card class="text-center">
                  <b-card-text>
                    Nenhum perfil adicionado
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col class="p-0" sm="12" lg="3" v-for="(itm, idx) in (user.roles || [])" v-bind:key="itm.clientId">
                <b-card class="text-center ">
                  <b-card-text>
                    <b>{{itm.name}}</b>
                  </b-card-text>
                  <b-row>
                    <b-col>
                      <b-button  class="form-control" href="#" variant="danger" size="sm" @click="removeRole(idx)">Remover</b-button>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-card-group>
          </b-form-group>
          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="primary" @click="save"><i class="fa fa-dot-circle-o"></i> Gravar</b-button>&nbsp;
              </b-col>
              <b-col sm="12" lg="2">
                <b-button type="button" variant="secondary" @click="goBack" class="form-control"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'underscore'

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      user: {
        roles: []
      },
      roles: [],
      role: null,
      loadCount: 0,
      provider: 'vault'
    }
  },
  mounted() {
    this.provider = this.$route.params.provider
    this.getUser(this.$route.params.id);
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    addRole() {
      if (this.role) {
        let role = _.findWhere(this.roles, {id: this.role});

        let alreadyExists = _.findWhere(this.user.roles, {name: role.name});
        if (!alreadyExists) {
          this.user.roles.push(role);
        }
        this.role = null;
      }
    },
    removeRole(idx) {
      this.user.roles.splice(idx, 1);
    },
    getUser(username) {
      var url;
      if (username) {
        url = `${env.urlBillingApi}/user-roles/${username}?provider=${this.provider}`;
      } else {
        url = `${env.urlBillingApi}/user-roles?provider=${this.provider}`;
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(url)
        .then(function(response) {
          _this.user = response.data.user || { roles: [] };
          _this.roles = [];
          response.data.roles.forEach(role => {
            _this.roles.push({
              id: role.id,
              name: role.roleId
            });
          });;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    save() {
      var _this = this;
      this.loadCount++;
      var data = {
        provider: this.provider,
        username: this.user.username,
        roles: _.pluck(this.user.roles, 'id')
      }
      axios
        .post(`${env.urlBillingApi}/user-roles`, data)
        .then(function(response) {
          console.log(response);
          _this.$bvModal.msgBoxOk('Perfis de usuário definidos com sucesso!')
            .then(value => {})
            .catch(console.error);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    goBack() {
      this.$router.replace({path: '/admin/users-role'});
      // this.$router.go(-1);
    },
  }
}
</script>
